export default {
  name: "Records-component",
  components: {},
  data() {
    return {
      parts: [],
      motifs: [],
      ops: [],
      part: "",
      fields: ["#", {
        key: "part",
        label: "Type",
        sortable: true
      }, {
        key: "motif_op",
        label: "Utilisateur",
        sortable: true
      }, {
        key: "date_op",
        label: "Date",
        sortable: true
      }, {
        key: "mnt",
        label: "Montant",
        sortable: true,
        tdClass: "text-right"
      }, "actions"],
      from_date: this.moment_date(),
      to_date: this.moment_date(),
      infoModal: {
        id: "info-modal",
        title: "",
        type: "",
        add_to_off: "false",
        content: {
          id_op: null,
          index: null,
          motif_op: "",
          part: "",
          type: "",
          date_op: this.moment_date(),
          mnt: 0
        }
      }
    };
  },
  computed: {
    recettes: function () {
      return this.ops.filter(el => el.type == "Recette");
    },
    depenses: function () {
      return this.ops.filter(el => el.type == "Depense");
    },
    recettes_mnt: function () {
      return this.recettes.reduce((a, b) => a + b.mnt, 0);
    },
    depenses_mnt: function () {
      return this.depenses.reduce((a, b) => a + b.mnt, 0);
    }
  },
  mounted() {
    const axios = require("axios");
    axios.get(this.$store.state.api_url + "/operations/get_parts", {
      headers: {
        Authorization: "Bearer " + this.$store.state.token
      }
    }).then(response => {
      const data = response.data;
      this.parts = data.map(el => el.part);
    }).catch(err => {
      if (err.response.status === 401) {
        console.log("uNauthorized request");
        console.log(err);
        this.error();
      } else {
        console.log("error : " + err);
      }
    });
    axios.get(this.$store.state.api_url + "/operations/get_motifs", {
      headers: {
        Authorization: "Bearer " + this.$store.state.token
      }
    }).then(response => {
      const data = response.data;
      this.motifs = data.map(el => el.motif_op);
    }).catch(err => {
      if (err.response.status === 401) {
        console.log("uNauthorized request");
        console.log(err);
        this.error();
      } else {
        console.log("error : " + err);
      }
    });
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      Object.assign(this.infoModal.content, item);
      this.infoModal.type = "Modifier";
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.type = "";
      this.infoModal.add_to_off = "false";
      this.infoModal.content = {
        id_op: null,
        index: null,
        motif_op: "",
        part: "",
        type: "",
        date_op: this.form_date,
        mnt: 0
      };
    },
    search() {
      const axios = require("axios");

      //this.isbusy = true;
      axios.post(this.$store.state.api_url + "/operations/get_operations", {
        ldate: this.moment_date(this.from_date),
        rdate: this.moment_date(this.to_date),
        part: this.part
      }, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token
        }
      }).then(response => {
        const data = response.data;
        this.ops = data.map((el, index) => {
          el.index = index;
          return el;
        });

        //this.isbusy = false;
      }).catch(err => {
        if (err.response.status === 401) {
          console.log("uNauthorized request");
          console.log(err);
          this.error();
        } else {
          console.log("error : " + err);
        }
      });
    },
    convert_to_date(value) {
      const moment = require("moment");
      return moment(value).format("DD/MM/YYYY");
    },
    error() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },
    moment_date(date) {
      var moment = require("moment");
      return moment(date).format("YYYY-MM-DD");
    },
    updateOperation() {
      const axios = require("axios");
      axios.post(this.$store.state.api_url + "/operations/update_operation", {
        id_op: this.infoModal.content.id_op,
        motif_op: this.infoModal.content.motif_op,
        date_op: this.infoModal.content.date_op,
        part: this.infoModal.content.part,
        mnt: this.infoModal.content.mnt
      }, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token
        }
      }).then(response => {
        console.log("Success :", response);
        //this.isbusy = false;
        this.$bvToast.toast("Modifié avec succée", {
          title: `Succée`,
          variant: "success",
          solid: true
        });
        this.ops.splice(this.infoModal.content.index, 1, this.infoModal.content);

        // this.ops.splice(this.ops.length);
      }).catch(err => {
        if (err.response.status === 401) {
          console.log("uNauthorized request");
          console.log(err);
          this.error();
        } else {
          console.log("error : " + err);
          this.$bvToast.toast("Erreur", {
            variant: "danger",
            solid: true
          });
        }
      }).finally(() => this.$root.$emit("bv::hide::modal", this.infoModal.id));
    },
    show_prompt_delete(row) {
      this.$bvModal.msgBoxConfirm("Merci de confirmer la suppression.", {
        title: "Confirmez SVP",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "Oui",
        cancelTitle: "Non",
        footerClass: "p-2",
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        console.log(value);
        if (value) {
          const axios = require("axios");
          axios.post(this.$store.state.api_url + "/operations/delete_operation", {
            id_op: row.item.id_op
          }, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token
            }
          }).then(response => {
            console.log("item", row.item);
            var index = this.ops.indexOf(row.item);
            this.ops.splice(index, 1);
            console.log("index", index);
            console.log("Success", response);
            this.$bvToast.toast("supprimée avec succée", {
              title: `Succée`,
              variant: "success",
              solid: true
            });
            //this.isbusy = false;
          }).catch(err => {
            if (err.response.status === 401) {
              console.log("uNauthorized request");
              console.log(err);
              this.error();
            } else {
              this.$bvToast.toast("Erreur", {
                variant: "danger",
                solid: true
              });
              console.log("error : " + err);
            }
          });
        }
      }).catch(err => {
        // An error occurred
        console.log(err);
      });
    },
    prompt_Add(type) {
      this.infoModal.content.date_op = this.from_date;
      this.infoModal.content.type = type;
      this.infoModal.type = "Ajouter";
      this.$root.$emit("bv::show::modal", this.infoModal.id);
    },
    AddOprtation() {
      var x = {
        motif_op: this.infoModal.content.motif_op,
        type: this.infoModal.content.type,
        date_op: this.infoModal.content.date_op,
        part: this.infoModal.content.part,
        mnt: this.infoModal.content.mnt
      };
      const axios = require("axios");
      axios.post(this.$store.state.api_url + "/operations/add_operation", x, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token
        }
      }).then(response => {
        console.log("Success :", response);
        //this.isbusy = false;
        if (this.infoModal.add_to_off == "true") axios.post(this.$store.state.api_url + "/operations/add_operation_off", x, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token
          }
        });
        this.infoModal.content.id_op = response.data.id;
        this.infoModal.content.index = this.ops.length;
        var moment = require("moment");
        if (moment(x.date_op).isBetween(this.from_date, this.to_date, undefined, "[]")) {
          this.ops.splice(this.ops.length, 1, this.infoModal.content);
        }
        //console.log(this.infoModal.content.type);
        //console.log(this.infoModal.content.type == "ٌRecette");

        this.$bvToast.toast("Ajouté avec succée", {
          title: `Succée`,
          variant: "success",
          solid: true
        });
      }).catch(err => {
        if (err.response.status === 401) {
          console.log("uNauthorized request");
          console.log(err);
          this.error();
        } else {
          console.log("error : " + err);
          this.$bvToast.toast("Erreur", {
            variant: "danger",
            solid: true
          });
        }
      }).finally(() => this.$root.$emit("bv::hide::modal", this.infoModal.id));
    },
    callFunction() {
      if (this.infoModal.type == "Ajouter") {
        console.log("launching add Operation");
        this.AddOprtation();
      } else {
        this.updateOperation();
        console.log("updating operation");
      }
    }
  },
  filters: {
    moment: function (date) {
      // console.log(date)
      var moment = require("moment");
      return moment(date).format("DD/MM/YYYY");
    },
    formatNumber: function (value) {
      if (isNaN(value)) return value;
      return new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    }
  }
};